<template>
  <div class="help-examples-container" style="">
    <TText text="Examples" font_weight="600" size="24" />
    <div class="help-examples-inner-container">
      <!-- DESCRIPTION OF PAGE -->
      <TText text="Here you can create examples." />
      <!-- ACTUAL ITEMS -->
      <div class="help-examples-item-container">
        <!-- CREATE DEFAULT PROJECT -->
        <div class="help-examples-item">
          <div class="help-examples-item-headline">
            <TText text="Create Example Project" font_weight="500" size="18" />
            <div class="help-examples-item-headline-line" />
          </div>
          <TText text="Creates an example project with an typical sequence and some pre-settings." font_weight="300" />
          <TText text="Beware! This is a German Sequence! More are coming soon!" font_weight="300"/>
          <div>
            <country-flag country="de" />
            <ButtonOutlined
              text="Create"
              width="200"
              color="green"
              @buttonClicked="createUObject({
              url: [
                {projects: ''},
                {'showWithEntitiesNormalized': ''}
              ],
              u_object: {
                name: 'Example Project',
                calendar_project_start: 'last monday'
              }
            }).then((id) => {
              joinProject({project_id: id}).then(() => {
                $router.push({
                  name: 'ProjectTaktPlan',
                  params: {
                    project_id: id,
                  }
                });
                enterEditMode({project_id: id}).then(() => {
                  createUObject({
                url: [
                  {projects: id},
                  {trains: 'completetrainsfromsequence'},
                  {showWithEntitiesNormalized: ''}
                ],
                u_object: {
                  sequence: 1,
                  is_community: true,
                  is_business: false,
                  trains: [{
                      name: 'Innenausbau',
                      description: '',
                      train_start: 0,
                      workable_backlog: false,
                      // position: train_index + 1 + direction,
                      taktareas: [{
                        name: 'A',
                        description: '',
                        taktarea_start: 0,
                        square_meter: 0,
                      },
                      {
                        name: 'B',
                        description: '',
                        taktarea_start: 1,
                        square_meter: 0,
                      }]
                  }]
                },
                trainsbacklogs: true,
              }).then(() => {
                  $router.push({
                    name: 'ProjectTaktPlan',
                    params: {
                      project_id: id,
                    }
                  });
                });  
                });
              });
            })"
            />
          </div>
        </div>

        <!-- CREATE DEFAULT SEQUENCE -->
        <!-- <div class="help-examples-item">
          <div class="help-examples-item-headline">
            <TText text="Create Default Sequence" font_weight="500" size="18" />
            <div class="help-examples-item-headline-line" />
          </div>
          <TText text="Hier nochmal eine Erklärung was genau der folgende Button macht" font_weight="300" />
          <div>
            <ButtonOutlined
              text="Create Default Sequence"
              width="200"
              color="green"
            />
          </div>
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
import CountryFlag from 'vue-country-flag';
import {
  // mapGetters,
  mapActions
} from 'vuex';

export default {
  components: {
    ButtonOutlined,
    CountryFlag 
  },

  data: () => ({

  }),
  methods: {
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    ...mapActions('Auth', [
      'joinProject'
    ]),
    ...mapActions('Project', [
      'enterEditMode'
    ]),
  }
};
</script>

<style>
.help-examples-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  grid-gap: 32px;
}
.help-examples-inner-container {
  display: flex;
  flex-direction: column;
  width: max(400px, 33vw);
}
.help-examples-item-container {
  display: flex;
  flex-direction: column;
  grid-gap: 32px;
  padding-top: 32px;
}
.help-examples-item {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.help-examples-item-headline {
  display: flex;
  grid-gap: 16px;
  align-items: center;
}
.help-examples-item-headline-line {
  border-bottom: 1px solid;
  color: inherit;
  flex: 1 1 0px;
}
</style>
